var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedSquigglyLineMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.349,
    height: 11.896,
    viewBox: "0 0 89.349 11.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "m3586.547 691.218-8.066-.527-8.4.085-8.171.656-7.772-.6-8.742-.3-8.336.661-7.729.171-8.409-.871-8.485.71-7.977-.167-.23 10.921 8.547.179 8.036-.673 8.073.837 8.571-.189 8.189-.641 7.769.26 8.521.659 8.45-.693 7.788-.079 8.313.543 7.091-.394v-10.94z",
    transform: "translate(-3504.235 -690.494)",
    style: {
      fill: "#629A41"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSquigglyLineMobile);
export default __webpack_public_path__ + "static/media/red-squiggly-line-mobile.3ff5433a2aca5db6e45523a153b40a4c.svg";
export { ForwardRef as ReactComponent };